class PressQuotesV2 extends HTMLElement {
  connectedCallback() {
    this.quoteEl = this.querySelector('[data-press-quote]');
    this.sourceEl = this.querySelector('[data-press-source]');
    this.quotes = Array.from(this.querySelectorAll('[data-press-quote-html]'));
    this.logos = Array.from(this.querySelectorAll('[data-press-logo]'));
    this.dots = Array.from(this.querySelectorAll('[data-press-dot]'));
    this.logosWrap = this.querySelector('[data-press-logos]');

    if (!this.quoteEl || this.logos.length === 0) return;

    this.interval = (Number.parseFloat(this.dataset.rotateSeconds) || 6) * 1000;
    this.active = this.logos.findIndex((el) => el.classList.contains('is-active'));
    if (this.active < 0) this.active = 0;

    this.hover = null;
    this.locked = false;
    this.timer = null;
    this.fader = null;

    this.handleLogoEnter = (event) => {
      const index = this.logos.indexOf(event.currentTarget);
      if (index < 0) return;
      this.hover = index;
      clearTimeout(this.timer);
      this.paint(index);
    };

    this.handleLogoClick = (event) => {
      const index = this.logos.indexOf(event.currentTarget);
      if (index < 0) return;
      this.locked = true;
      this.hover = null;
      this.show(index);
    };

    this.handleDotClick = (event) => {
      const index = this.dots.indexOf(event.currentTarget);
      if (index < 0) return;
      this.locked = true;
      this.hover = null;
      this.show(index);
    };

    this.handleLogosLeave = () => {
      this.hover = null;
      this.paint(this.active);
      this.tick();
    };

    this.logos.forEach((logo) => {
      logo.addEventListener('mouseenter', this.handleLogoEnter);
      logo.addEventListener('focus', this.handleLogoEnter);
      logo.addEventListener('click', this.handleLogoClick);
    });

    this.dots.forEach((dot) => {
      dot.addEventListener('click', this.handleDotClick);
    });

    this.logosWrap?.addEventListener('mouseleave', this.handleLogosLeave);

    this.paint(this.active);
    this.tick();
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
    clearTimeout(this.fader);

    this.logos?.forEach((logo) => {
      logo.removeEventListener('mouseenter', this.handleLogoEnter);
      logo.removeEventListener('focus', this.handleLogoEnter);
      logo.removeEventListener('click', this.handleLogoClick);
    });

    this.dots?.forEach((dot) => {
      dot.removeEventListener('click', this.handleDotClick);
    });

    this.logosWrap?.removeEventListener('mouseleave', this.handleLogosLeave);
  }

  quoteHtml(index) {
    return this.quotes[index] ? this.quotes[index].innerHTML : '';
  }

  paint(index) {
    this.quoteEl.innerHTML = this.quoteHtml(index);

    const source = this.logos[index]?.dataset.source || '';
    if (this.sourceEl) {
      this.sourceEl.textContent = source ? `— ${source}` : '';
    }

    this.logos.forEach((logo, i) => {
      logo.classList.toggle('is-active', i === index);
    });

    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
  }

  show(index) {
    if (index === this.active) return;

    clearTimeout(this.fader);
    this.classList.add('is-fading');
    this.fader = setTimeout(() => {
      this.active = index;
      this.paint(index);
      this.classList.remove('is-fading');
    }, 160);
  }

  tick() {
    clearTimeout(this.timer);
    if (this.locked || this.hover !== null || this.logos.length < 2) return;

    this.timer = setTimeout(() => {
      this.show((this.active + 1) % this.logos.length);
      this.tick();
    }, this.interval);
  }
}

if (!customElements.get('press-quotes-v2')) {
  customElements.define('press-quotes-v2', PressQuotesV2);
}
